import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { experimentsPublicRoutesConstants as routesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

const SharedExperiments = lazy(() =>
  componentLazyImport(() => import("../../pages/SharedExperiments"))
);

const SharedExperiment = lazy(() =>
  componentLazyImport(() => import("../../pages/SharedExperiment"))
);

const SingleSharedExperiment = lazy(() =>
  componentLazyImport(() => import("../../pages/SingleSharedExperiment"))
);

const WatchtowerExperiment = lazy(() =>
  componentLazyImport(() => import("../../pages/WatchtowerExperiment"))
);

const ExperimentsPublicRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.watchtower_experiment.path}>
        <WatchtowerExperiment />
      </Route>

      <Route path={routesConstants.single_shared_experiment.path}>
        <SingleSharedExperiment />
      </Route>

      <Route path={routesConstants.shared_experiment.path}>
        <SharedExperiment />
      </Route>

      <Route path={routesConstants.shared_experiments.path}>
        <SharedExperiments />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default ExperimentsPublicRoutes;
